import React from 'react';

// NEW: Lean player matrix options
export const VS_AGGRESSION_OPTIONS = {
    unknown: { label: 'Unknown', color: 'bg-gray-400' },
    calls_light: { label: 'Calls Light', color: 'bg-green-500', exploit: 'Value bet relentlessly' },
    folds_too_much: { label: 'Folds Too Much', color: 'bg-red-500', exploit: 'Bluff more' },
    balanced: { label: 'Balanced', color: 'bg-blue-500', exploit: 'Standard play' },
};

export const AGGRESSION_STYLE_OPTIONS = {
    unknown: { label: 'Unknown', color: 'bg-gray-400' },
    passive: { label: 'Passive', color: 'bg-yellow-400', exploit: 'Bet for value more' },
    aggressive: { label: 'Aggressive', color: 'bg-red-400', exploit: 'Call down light' },
    balanced: { label: 'Balanced', color: 'bg-blue-500', exploit: 'Standard play' },
};

export const PREFLOP_HANDS_OPTIONS = {
    unknown: { label: 'Unknown', color: 'bg-gray-400' },
    loose: { label: 'Loose', color: 'bg-red-400', exploit: 'Widen value range' },
    standard: { label: 'Standard', color: 'bg-blue-400', exploit: 'Standard play' },
    tight: { label: 'Tight', color: 'bg-green-400', exploit: 'Steal blinds' },
};

export const PREFLOP_AGGRESSION_OPTIONS = {
    unknown: { label: 'Unknown', color: 'bg-gray-400' },
    passive: { label: 'Passive', color: 'bg-yellow-400', exploit: 'ISO-raise wide' },
    aggressive: { label: 'Aggressive', color: 'bg-red-400', exploit: 'Tighten 4-bet range' },
    balanced: { label: 'Balanced', color: 'bg-blue-400', exploit: 'Standard play' },
};

// Player categories with colors
export const PLAYER_CATEGORIES = {
    shark: { label: 'Shark', bgColor: 'bg-black' },
    reg: { label: 'Reg', bgColor: 'bg-red-500' },
    fish: { label: 'Fish', bgColor: 'bg-green-500' },
    whale: { label: 'Whale', bgColor: 'bg-pink-500' },
    nit: { label: 'Nit', bgColor: 'bg-blue-500' },
    unknown: { label: 'Unknown', bgColor: 'bg-gray-400' }
};

export const PLAYER_TYPES = PLAYER_CATEGORIES;

// Matrix badge component
export const MatrixBadge = ({ value, options, size = 'sm' }) => {
    const config = options[value] || options.unknown;
    const sizeClass = size === 'sm' ? 'px-2 py-0.5 text-xs' : 'px-3 py-1 text-sm';

    return (
        <span className={`${config.color} ${sizeClass} rounded-full text-white font-medium`}>
            {config.label}
        </span>
    );
};

// Player matrix summary component
export const PlayerMatrixSummary = ({ player, compact = false }) => {
    if (compact) {
        return (
            <div className="flex flex-wrap gap-1">
                <MatrixBadge value={player.preflop_hands} options={PREFLOP_HANDS_OPTIONS} />
                <MatrixBadge value={player.preflop_aggression} options={PREFLOP_AGGRESSION_OPTIONS} />
            </div>
        );
    }

    return (
        <div className="space-y-2">
            <div className="flex items-center gap-2 text-sm">
                <span className="text-gray-500 dark:text-gray-400 w-20">Preflop:</span>
                <MatrixBadge value={player.preflop_hands} options={PREFLOP_HANDS_OPTIONS} />
                <MatrixBadge value={player.preflop_aggression} options={PREFLOP_AGGRESSION_OPTIONS} />
            </div>
            <div className="flex items-center gap-2 text-sm">
                <span className="text-gray-500 dark:text-gray-400 w-20">vs Aggro:</span>
                <MatrixBadge value={player.vs_aggression} options={VS_AGGRESSION_OPTIONS} />
            </div>
            <div className="flex items-center gap-2 text-sm">
                <span className="text-gray-500 dark:text-gray-400 w-20">Style:</span>
                <MatrixBadge value={player.aggression_style} options={AGGRESSION_STYLE_OPTIONS} />
            </div>
        </div>
    );
};

const PlayerTypeIcon = ({ playerType = 'unknown', size = 'w-6 h-6', showLabel = false, className = '' }) => {
    const typeConfig = PLAYER_TYPES[playerType] || PLAYER_TYPES.unknown;

    return (
        <div className={`flex items-center gap-2 ${className}`}>
            <div className={`${size} ${typeConfig.bgColor} rounded-full flex-shrink-0`}></div>
            {showLabel && (
                <span className="text-sm font-medium text-gray-900 dark:text-white">
                    {typeConfig.label}
                </span>
            )}
        </div>
    );
};

export default PlayerTypeIcon;
